import { JsonObject, UiOption } from '@/lib/helpers';
import { AwsS3TelemetryConfig, AwsS3TelemetryModel } from './aws-s3-telemetry.model';
import { TelemetryModel } from './telemetry.model';
import { cloneDeep } from 'lodash';
import { SplunkTelemetryConfig, SplunkTelemetryModel } from './splunk-telemetry.model';
import { CrowdStrikeTelemetryConfig, CrowdStrikeTelemetryModel } from './crowdstrike-telemetry.model';
import { HttpTelemetryConfig, HttpTelemetryModel } from './http-telemetry.model';
import { DatadogTelemetryConfig, DatadogTelemetryModel } from './datadog-telemetry.model';

export type TelemetryType = 's3' | 'http' | 'splunk' | 'crowdstrike' | 'datadog' | 'unknown';

export type TelemetryConfig =
  | AwsS3TelemetryConfig
  | SplunkTelemetryConfig
  | CrowdStrikeTelemetryConfig
  | HttpTelemetryConfig
  | DatadogTelemetryConfig;

export const TelemetryMap: Map<TelemetryType, TelemetryModel> = new Map();

TelemetryMap.set('s3', new AwsS3TelemetryModel());
TelemetryMap.set('splunk', new SplunkTelemetryModel());
TelemetryMap.set('crowdstrike', new CrowdStrikeTelemetryModel());
TelemetryMap.set('http', new HttpTelemetryModel());
TelemetryMap.set('datadog', new DatadogTelemetryModel());

export const getTypedTelemetry = (model: TelemetryModel) => {
  const typedModel = TelemetryMap.get(model.type);

  if (!typedModel) {
    return model;
  }

  const Constructor = typedModel.constructor as new (data?: JsonObject) => typeof typedModel;

  const config = {
    ...typedModel.config,
    ...model.config,
  };

  const data = cloneDeep({ ...model._props, config });

  return new Constructor(data)!;
};

export const getTelemetryOptions = (): UiOption[] => {
  return Array.from(TelemetryMap.entries()).map(([type, model]) => {
    const { typeLabel } = model;

    return {
      label: typeLabel,
      value: type as string,
    };
  });
};

export const getHttpAuthTypeOptions = (): UiOption[] => {
  return [
    { label: 'None', value: 'none' },
    { label: 'Bearer', value: 'bearer' },
    { label: 'Custom', value: 'api_key' },
  ];
};

export const getDatadogSiteOptions = (): UiOption[] => {
  return [
    { label: 'datadoghq.com (US1)', value: 'datadoghq.com' },
    { label: 'datadoghq.eu (EU)', value: 'datadoghq.eu' },
    { label: 'us3.datadoghq.com (US3)', value: 'us3.datadoghq.com' },
    { label: 'us5.datadoghq.com (US5)', value: 'us5.datadoghq.com' },
    { label: 'ap1.datadoghq.com (AP1)', value: 'ap1.datadoghq.com' },
    { label: 'ap2.datadoghq.com (AP2)', value: 'ap2.datadoghq.com' },
    { label: 'ddog-gov.com (US1-FED)', value: 'ddog-gov.com' },
  ];
};
